import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, Actions, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BrickSettingsService, DynamicActionsBrickSettingRemoteDto } from 'src/generated/swagger';
import { IBrickSettingStateModel, SpecificBrickSettingsStateBase } from '../specific-brick-settings-base';
import { ChangeJsonConfiguration } from './dynamic-actions-brick-settings.actions';

export interface DynamicActionsBrickSettingsStateModel extends IBrickSettingStateModel<DynamicActionsBrickSettingRemoteDto> {}
function getDefaultSpecificBrickSetting(): DynamicActionsBrickSettingRemoteDto {
   return {
      commonBrickSettingRemoteDto: null,
      jsonConfiguration: null,
   };
}

@Injectable()
@State<DynamicActionsBrickSettingsStateModel>({
   name: 'dynamicActionsBrickSettings',
   defaults: {
      specificBrickSettings: {
         brickSettings: {},
         brickSettingsEditMode: null,
      },
   },
})
export class DynamicActionsBrickSettingsState extends SpecificBrickSettingsStateBase<DynamicActionsBrickSettingRemoteDto>(getDefaultSpecificBrickSetting) {
   constructor(private brickSettingsService: BrickSettingsService, store: Store, actions$: Actions) {
      super(store);
   }

   @Selector([DynamicActionsBrickSettingsState, DynamicActionsBrickSettingsState.getSettingModelFn])
   public static getJsonConfigurationFn(
      state: DynamicActionsBrickSettingsStateModel,
      getSettingModelFn: (state, brickInstanceId) => DynamicActionsBrickSettingRemoteDto
   ) {
      return (brickInstanceId: string) => {
         return getSettingModelFn(state, brickInstanceId).jsonConfiguration;
      };
   }

   @Action(ChangeJsonConfiguration)
   @ImmutableContext()
   public changeJsonConfiguration(ctx: StateContext<DynamicActionsBrickSettingsStateModel>, action: ChangeJsonConfiguration) {
      ctx.setState((state: DynamicActionsBrickSettingsStateModel) => {
         const brickSettingModel: DynamicActionsBrickSettingRemoteDto = DynamicActionsBrickSettingsState.getSettingModelOrDefault(
            state,
            action.brickInstanceId
         );
         brickSettingModel.jsonConfiguration = action.jsonConfiguration;
         state.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
         return state;
      });
   }

   protected doSaveSpecificSettings(brickInstanceId: string, brickSetting: DynamicActionsBrickSettingRemoteDto): Observable<any> {
      return this.brickSettingsService.changeDynamicActionsBrickSettings({
         brickInstanceId: brickInstanceId,
         settings: brickSetting,
      });
   }
}
